module.exports = __webpack_public_path__ + "static/media/step-1.c3240439.svg";